import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";
import { CaseStudy } from "../src/landingPage/views/CaseStudy/CaseStudy";
import { meta } from "../src/landingPage/datasets/meta";

const CaseStudyPage = () => {
  return (
    <>
      <NextHead
        currentPath="/resources"
        title={meta.case_study.title}
        description={meta.case_study.description}
      />
      <CaseStudy />
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default CaseStudyPage;
